<micro-select-combo #sel
              placeholder="Rating Type"
              valueField="id"
              [mode]="mode"
              [(id)]="ratingType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
